export enum InstitutionStatusNamesEnum {
  IP = 'In Progress',
  C = 'Completed',
}
